// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__iLP9r","large":"styles_large__1pMUR"};